/**
 * quickTestNames.ts
 *
 * The name of the Quick Tests tile a person clicked, keyed by the system flow
 * the tile runs. Test runs store the flow's own name ("Quick Network Test"),
 * which is not what the person picked; the Tests page shows this instead.
 * Keep in sync with `testMetadata` labels in pages/QuickTestsPage.tsx.
 */

const QUICK_TEST_NAME_BY_FLOW_ID: Record<string, string> = {
  sys_quick_network_test_flow: 'Network Connection Test',
  sys_quick_sms_test_flow: 'SMS Test',
  sys_quick_data_test_flow: 'Data Connection Test',
  sys_quick_data_performance_test_flow: 'Data Performance Test',
  sys_quick_iot_mqtt_test_flow: 'IoT (MQTT)',
  sys_quick_iperf_test_flow: 'iperf3 Throughput',
  sys_quick_speedtest_test_flow: 'Speed Test',
  sys_quick_voice_call_test_flow: 'Voice Call Check',
  sys_quick_voice_agent_test_flow: 'Calling Card Check',
};

/** The Quick Tests tile name for a run's flow, or undefined for any other flow. */
export function quickTestName(flowId?: string | null): string | undefined {
  return flowId ? QUICK_TEST_NAME_BY_FLOW_ID[flowId] : undefined;
}
